import React from "react";

function PIRMotionSensor() {
  return (
    <div>

      <h2>PIR Motion Sensor Interfacing with Raspberry Pi using Python</h2>

      <img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/339/icon/PIR%20Motion%20Sensor%20Interfacing%20with%20Raspberry%20Pi%20using%20Python%202.jpg"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<h3>Overview of PIR Sensor</h3>
<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/339/description/PIR%20Sensor.jpg"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>
     <h3>PIR Sensor Module</h3>

<ol>
  <li>
    PIR (Passive Infrared) sensor is used for detecting infrared heat radiation.
  </li>
  <li>
    It is useful for detecting moving living objects that emit infrared radiation.
  </li>
  <li>
    The output of the PIR sensor is HIGH when motion is detected.
  </li>
  <li>
    The output remains LOW when there is no motion or the object is stationary.
  </li>
  <li>
    It is widely used in applications like automatic room lighting and security systems.
  </li>
</ol>

<p>
  For more information about the PIR sensor and how to use it, refer to the 
  <strong>PIR Sensor Module</strong> in the sensors and modules section.
</p>


<h3>Connection Diagram of PIR Sensor with Raspberry Pi</h3>
<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/339/description/PIR%20Interface%20with%20Raspberry.png"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/339/description/Connections%20for%20PIR%20Motion%20Sensor%20Interfacing%20with%20Raspberry%20Pi%20using%20Python.jpg"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<h3>Note</h3>

<ul>
  <li>
    Do not place the PIR sensor close to Wi-Fi antennas, ESP32, or NodeMCU.
  </li>
  <li>
    Wi-Fi signals emit electromagnetic radiation which can interfere with 
    PIR sensor performance.
  </li>
  <li>
    This interference may cause false motion detection.
  </li>
  <li>
    Always keep the PIR sensor and Wi-Fi sources as far apart as possible.
  </li>
  <li>
    Shielding techniques like metal enclosures or Faraday cages can be used 
    to reduce interference.
  </li>
</ul>

<h3>Example</h3>

<p>
  In this example, we interface a PIR sensor with Raspberry Pi to detect motion.
</p>

<p>
  When motion is detected, the PIR sensor output goes HIGH. This signal is read 
  by the Raspberry Pi, which then turns ON an LED.
</p>

<ul>
  <li>PIR output is connected to GPIO5 (pin 29)</li>
  <li>LED is connected to GPIO12 (pin 32)</li>
</ul>

<p>
  A Python program is used to read the PIR sensor data and control the LED. 
  To learn more about GPIO access on Raspberry Pi, refer to 
  <strong>Raspberry Pi GPIO Access</strong>.
</p>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/339/description/PIR%20Motion%20Sensor%20Interfacing%20with%20Raspberry%20Pi%20using%20Python%201.jpg"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<h3>PIR Sensor Python Program for Raspberry Pi</h3>

<div
  style={{
    backgroundColor: "#f4f4f4",
    padding: "15px",
    borderRadius: "10px",
    maxHeight: "400px",
    overflowY: "scroll",
    border: "1px solid #ccc",
  }}
>
  <pre style={{ margin: 0 }}>
{`"
Motion detection using PIR on Raspberry Pi
http://www.electronicwings.com
"

import RPi.GPIO as GPIO

PIR_input = 29   # read PIR output
LED = 32         # LED for motion indication

GPIO.setwarnings(False)
GPIO.setmode(GPIO.BOARD)

GPIO.setup(PIR_input, GPIO.IN)
GPIO.setup(LED, GPIO.OUT)

GPIO.output(LED, GPIO.LOW)

while True:
    # when motion detected turn ON LED
    if(GPIO.input(PIR_input)):
        GPIO.output(LED, GPIO.HIGH)
    else:
        GPIO.output(LED, GPIO.LOW)
`}
  </pre>
</div>


    </div>
  );
}

export default PIRMotionSensor;